import script from "./AutoAIAgentSelector.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAIAgentSelector.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAIAgentSelector.vue?vue&type=style&index=0&id=4e45482a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e45482a"]])

export default __exports__